import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { Shield, Droplets, Clock, Home as HomeIcon, CheckCircle, MapPin, Star, Phone } from 'lucide-react';
import { TrustBar } from '../components/TrustBar';
import { ServiceCard } from '../components/ServiceCard';
import { BeforeAfterSlider } from '../components/BeforeAfterSlider';
import { CTABanner } from '../components/CTABanner';
export function Home() {
  return <div className="w-full" data-id="element-390" data-mp="1zjifa35yy9x8">
      {/* 1. Video Hero Header */}
      <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden bg-navy" data-id="element-391" data-mp="24g8u6n61ezh2">
        {/* Video Background — pressure washing exterior */}
        <video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover z-0" data-id="element-392" data-mp="2dhgs344n5yam">
          <source src="https://cdn.magicpatterns.com/uploads/diBgE4VrUi92699QGew8Zr/softwash pros Macomb and Oakland County.mp4" type="video/mp4" data-id="element-393" data-mp="3kxd2z8tam91b" />
        </video>

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-navy/70 z-10" data-id="element-394" data-mp="2vxot1li871jp"></div>

        {/* Hero Content */}
        <div className="relative z-20 text-center px-4 max-w-5xl mx-auto mt-16 flex flex-col items-center" data-id="element-395" data-mp="2qylnlzyc2tb7">
          <img src="https://cdn.magicpatterns.com/uploads/5AVKXiTXV1VVA3kGuFBhc2/TheSoftwashPros-logo.jpg" alt="Softwash Pros Logo" className="h-24 md:h-32 mb-6 rounded-2xl shadow-2xl" data-id="element-396" data-mp="2mxa6yjxftif5" />
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-montserrat font-black text-white mb-6 leading-tight text-shadow-lg" data-id="element-397" data-mp="2d65qtgw0zriq">
            We Clean It So You Don't Have To!
          </h1>
          <p className="text-xl md:text-2xl text-cream mb-10 max-w-3xl mx-auto font-medium text-shadow" data-id="element-398" data-mp="23a2hnr2rasma">
            Safe, eco-friendly, and longer-lasting alternative to pressure
            washing. We restore your property's beauty without the damage.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-399" data-mp="1kkz0v9khhnqq">
            <Link to="/contact" className="w-full sm:w-auto bg-light-blue text-dark font-bold py-4 px-8 rounded-md hover:bg-white transition-colors text-lg shadow-lg" data-id="element-400" data-mp="1omc6bijnzox4">
              Get a Free Quote
            </Link>
            <Link to="/services" className="w-full sm:w-auto bg-transparent border-2 border-white text-white font-bold py-4 px-8 rounded-md hover:bg-white hover:text-navy transition-colors text-lg" data-id="element-401" data-mp="1fm5wq7r37938">
              Our Services
            </Link>
          </div>

          <div className="mt-8 flex items-center justify-center text-white text-xl font-bold" data-id="element-402" data-mp="1tkvsnk2672q0">
            <Phone className="w-6 h-6 mr-2 text-light-blue" data-id="element-403" data-mp="1yixc463id420" />
            <a href="tel:586-298-2727" className="hover:text-light-blue transition-colors" data-id="element-404" data-mp="2m9kmcy0wc5rq">
              586-298-2727
            </a>
          </div>
        </div>
      </section>

      {/* 2. Trust Bar */}
      <TrustBar data-id="element-405" data-mp="fjzhpr1b6ges" />

      {/* 3. Services Overview */}
      <section className="py-20 bg-gray-50" data-id="element-406" data-mp="an8yiuu7j4p5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-407" data-mp="amh6tv3qdr45">
          <div className="text-center mb-16" data-id="element-408" data-mp="od2ojghg7v0g">
            <h2 className="text-3xl md:text-4xl font-montserrat text-navy mb-4" data-id="element-409" data-mp="ofyofacuwtrj">
              Our Exterior Cleaning Services
            </h2>
            <div className="w-24 h-1 bg-light-blue mx-auto mb-6" data-id="element-410" data-mp="3srkffpswol9b"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-411" data-mp="3nt96dhafqes5">
              We use specialized soft washing techniques tailored to each
              surface, ensuring a deep clean without the risk of high-pressure
              damage.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-412" data-mp="qnv2dxu61nf">
            <ServiceCard title="Residential Soft Washing" description="Complete exterior house washing safe for siding, stucco, and brick." icon={HomeIcon} linkTo="/services/residential" data-id="element-413" data-mp="1h18c0azvzy3z" />
            <ServiceCard title="Roof Cleaning" description="Remove black streaks, moss, and algae safely to extend your roof's lifespan." icon={HomeIcon} linkTo="/services/roof" data-id="element-414" data-mp="2ccg9gwpnn2tx" />
            <ServiceCard title="Gutter Cleaning" description="Inside and out gutter cleaning to ensure proper flow and a bright appearance." icon={Droplets} linkTo="/services/gutter" data-id="element-415" data-mp="2mcguqo733t0r" />
            <ServiceCard title="Driveway & Concrete" description="Restore concrete surfaces, removing dirt, oil, and organic growth." icon={HomeIcon} linkTo="/services/driveway" data-id="element-416" data-mp="3020urm9a6c6d" />
            <ServiceCard title="Deck & Patio" description="Safe cleaning for wood, composite, and stone outdoor living spaces." icon={HomeIcon} linkTo="/services/deck" data-id="element-417" data-mp="3a2kxktcg7oqp" />
            <ServiceCard title="Fence Cleaning" description="Revitalize wood and vinyl fences, removing graying and mildew." icon={HomeIcon} linkTo="/services/fence" data-id="element-418" data-mp="ydmr9vhbynr4" />
            <ServiceCard title="Commercial Services" description="Keep your business looking professional and inviting for customers." icon={HomeIcon} linkTo="/commercial" data-id="element-419" data-mp="ogig0qp0wcp3" />
            <div className="bg-navy rounded-xl p-8 shadow-soft flex flex-col items-center justify-center text-center h-full border border-navy" data-id="element-420" data-mp="1h68lycgi48a4">
              <h3 className="text-2xl font-montserrat text-white mb-4" data-id="element-421" data-mp="17d1jazd5b6dq">
                Need a Custom Quote?
              </h3>
              <p className="text-cream mb-6" data-id="element-422" data-mp="24urtgprq8h15">
                We handle properties of all sizes.
              </p>
              <Link to="/contact" className="bg-light-blue text-dark font-bold py-3 px-6 rounded hover:bg-white transition-colors w-full" data-id="element-423" data-mp="200nm45eju6zj">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 4. Before & After Slider Section */}
      <section className="py-20 bg-white" data-id="element-424" data-mp="3pj2lro0ycrrg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-425" data-mp="3pi1bvmvoabbb">
          <div className="text-center mb-16" data-id="element-426" data-mp="3aljykq3xamm4">
            <h2 className="text-3xl md:text-4xl font-montserrat text-navy mb-4" data-id="element-427" data-mp="3aoy2w3w5d5w7">
              See the Difference
            </h2>
            <div className="w-24 h-1 bg-light-blue mx-auto mb-6" data-id="element-428" data-mp="31mgepjwxm36k"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-429" data-mp="31o9pnbekv9kd">
              Drag the slider to see the instant restoration our soft washing
              process provides.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-430" data-mp="14tmxp0t4bh5i">
            <BeforeAfterSlider label="Roof Cleaning" beforeImage="https://cdn.magicpatterns.com/uploads/8UYgz7m3eX6fND37jH9tvX/Roof_Cleaning_-_Before.jpg" afterImage="https://cdn.magicpatterns.com/uploads/pP5TtUKDtk9um4YeGC6HAC/Roof_Cleaning_-_After.jpg" data-id="element-431" data-mp="14svdsn8vv7v2" />
            <BeforeAfterSlider label="Driveway Cleaning" beforeImage="https://cdn.magicpatterns.com/uploads/tCPBXWxumYQZAmGBqwAaB2/Driveway_Cleaning_-_Before.jpg" afterImage="https://cdn.magicpatterns.com/uploads/efTEU7TcKBJVE8JdDx7CNP/Driveway_Cleaning_-_After.jpg" data-id="element-432" data-mp="1nrzzb7vuo8o7" />
            <BeforeAfterSlider label="House Siding" beforeImage="https://cdn.magicpatterns.com/uploads/pnCzZLbUo4gmP4HJg6Q6je/House_Siding_Cleaning_-_Before.jpg" afterImage="https://cdn.magicpatterns.com/uploads/uDxT5qTeij1ZyoQ4ZdHNub/House_Siding_Cleaning_-_After.jpg" data-id="element-433" data-mp="26ohmdbzr7ke4" />
            <BeforeAfterSlider label="Deck Restoration" beforeImage="https://cdn.magicpatterns.com/uploads/fQCsqdiU3PXf4aYBJPePvd/Deck__Fence_-_Before.jpg" afterImage="https://cdn.magicpatterns.com/uploads/kTvX7zmN6vv8tUusET97SW/Deck__Fence_-_After.jpg" data-id="element-434" data-mp="89wu9ymr4dx6" />
          </div>

          {/* <div className="text-center mt-12">
           <Link
           to="/gallery"
           className="inline-flex items-center text-navy font-bold hover:text-light-blue transition-colors text-lg"
           >
           View Full Gallery
           </Link>
           </div> */}
        </div>
      </section>

      {/* 5. Why Choose Softwash Pros */}
      <section className="py-20 bg-cream" data-id="element-435" data-mp="mvdv5mujgc26">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-436" data-mp="mukkwbwdf4fa">
          <div className="text-center mb-16" data-id="element-437" data-mp="rv8jpjqucpk2">
            <h2 className="text-3xl md:text-4xl font-montserrat text-navy mb-4" data-id="element-438" data-mp="rsvvwpyejkz3">
              Why Choose Softwash Pros?
            </h2>
            <div className="w-24 h-1 bg-navy mx-auto mb-6" data-id="element-439" data-mp="239m4ugu7mqwe"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-440" data-mp="2de2ir4o4pxxk">
            {[{
            icon: Shield,
            title: 'Safe for All Surfaces',
            desc: 'Low pressure prevents damage to siding, shingles, and paint.'
          }, {
            icon: Droplets,
            title: 'Eco-Friendly Solutions',
            desc: '100% biodegradable cleaning agents safe for pets and plants.'
          }, {
            icon: Clock,
            title: 'Longer-Lasting Results',
            desc: 'Kills algae and mold at the root, lasting 4-6x longer than pressure washing.'
          }, {
            icon: CheckCircle,
            title: 'No Damage Guarantee',
            desc: 'We never use high pressure on delicate exterior surfaces.'
          }, {
            icon: Shield,
            title: 'Fully Licensed & Insured',
            desc: 'Complete peace of mind while we are working on your property.'
          }, {
            icon: Star,
            title: 'Free, Fast Quotes',
            desc: 'Transparent pricing with no hidden fees or surprises.'
          }].map((item, idx) => <div key={idx} className="bg-white p-8 rounded-xl shadow-sm flex flex-col items-center text-center" data-id="element-441" data-mp="hneokm4k3kl9" data-mpi={idx}>
                <div className="w-16 h-16 bg-light-blue/10 rounded-full flex items-center justify-center mb-6" data-id="element-442" data-mp="3q156vtnkzwmi">
                  <item.icon className="w-8 h-8 text-navy" data-id="element-443" data-mp="3nn2dy3vyxw6" />
                </div>
                <h3 className="text-xl font-montserrat text-navy mb-3" data-id="element-444" data-mp="3pq3peahodg7">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-445" data-mp="37cgmd8t0ftb9">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 6. How It Works */}
      <section className="py-20 bg-white" data-id="element-446" data-mp="32bsu6jt1p6fg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-447" data-mp="1hvmfba9d2hek">
          <div className="text-center mb-16" data-id="element-448" data-mp="1mmkyqipnbvm1">
            <h2 className="text-3xl md:text-4xl font-montserrat text-navy mb-4" data-id="element-449" data-mp="1mnmjxg0dlyhh">
              How It Works
            </h2>
            <div className="w-24 h-1 bg-light-blue mx-auto mb-6" data-id="element-450" data-mp="18x109p33lkij"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-451" data-mp="1cxb5v0mza8wv">
            {/* Connecting Line (Desktop) */}
            <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-1 bg-gray-200 z-0" data-id="element-452" data-mp="20k9hnl05ksog"></div>

            {[{
            step: '1',
            title: 'Get a Free Quote',
            desc: "Call or fill out our form. We'll provide a fast, transparent estimate."
          }, {
            step: '2',
            title: 'Scheduled Service',
            desc: 'Our professional team arrives on time with state-of-the-art equipment.'
          }, {
            step: '3',
            title: 'Sparkling Results',
            desc: 'Enjoy a beautifully restored exterior with our satisfaction guarantee.'
          }].map((item, idx) => <div key={idx} className="relative z-10 flex flex-col items-center text-center" data-id="element-453" data-mp="2d3wu0hvelb4o" data-mpi={idx}>
                <div className="w-24 h-24 bg-navy text-white rounded-full flex items-center justify-center text-3xl font-montserrat font-bold border-8 border-white shadow-md mb-6" data-id="element-454" data-mp="291jxmk2jqpkk">
                  {item.step}
                </div>
                <h3 className="text-2xl font-montserrat text-navy mb-3" data-id="element-455" data-mp="1u5khcm5a9j4c">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-lg" data-id="element-456" data-mp="1q5tu2seytl4k">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 7. Customer Reviews */}
      <section className="py-20 bg-gray-50" data-id="element-457" data-mp="3ki9wtj8jyh4o">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-458" data-mp="3kgfbi3tdcn02">
          <div className="text-center mb-16" data-id="element-459" data-mp="169pllut70gxp">
            <h2 className="text-3xl md:text-4xl font-montserrat text-navy mb-4" data-id="element-460" data-mp="168xwn2u3phge">
              What Our Clients Say
            </h2>
            <div className="w-24 h-1 bg-light-blue mx-auto mb-6" data-id="element-461" data-mp="1g0247hhg6017"></div>
            <div className="flex items-center justify-center space-x-2 text-yellow-400 mb-2" data-id="element-462" data-mp="1k25q701qsn0q">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-current" data-id="element-463" data-mp="ncy4ns14idwt" />)}
            </div>
            <p className="text-gray-600 font-semibold" data-id="element-464" data-mp="sc0yegbnkxph">5.0 Average Rating</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-465" data-mp="wcbckg9lmuff">
            {[{
            name: 'Sarah M.',
            text: "Incredible difference! Our roof looks brand new and they didn't use any high pressure that could damage the shingles. Highly recommend Softwash Pros!"
          }, {
            name: 'John D.',
            text: "Professional, on time, and the results speak for themselves. The siding on our house hasn't looked this good since we bought it 10 years ago."
          }, {
            name: 'Michael R.',
            text: 'They cleaned our driveway and patio. The team was respectful of our landscaping and the eco-friendly solutions worked perfectly. Great local company.'
          }].map((review, idx) => <div key={idx} className="bg-white p-8 rounded-xl shadow-soft border border-gray-100 relative" data-id="element-466" data-mp="2u6p110cdpdz1" data-mpi={idx}>
                <div className="text-light-blue opacity-20 absolute top-4 right-6 text-6xl font-serif" data-id="element-467" data-mp="33ymbu5zh63x8">
                  "
                </div>
                <div className="flex text-yellow-400 mb-4" data-id="element-468" data-mp="2z1cp4y3h06d3">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-469" data-mp="3cwohwzy2fmrd" />)}
                </div>
                <p className="text-gray-600 mb-6 relative z-10 italic" data-id="element-470" data-mp="3rlq5zxskz8js">
                  "{review.text}"
                </p>
                <div className="font-montserrat font-bold text-navy" data-id="element-471" data-mp="foslil582uz">
                  - {review.name}
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. Service Area */}
      <section className="py-20 bg-white border-t border-gray-100" data-id="element-472" data-mp="3ml276py41nf0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-473" data-mp="38uyo27uj29ts">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-474" data-mp="3dlyohn2uva11">
            <div className="lg:w-1/2" data-id="element-475" data-mp="3do1n2vi2qbhd">
              <h2 className="text-3xl md:text-4xl font-montserrat text-navy mb-6" data-id="element-476" data-mp="2yxkn7gl37tml">
                Proudly Serving the Area
              </h2>
              <p className="text-lg text-gray-600 mb-8" data-id="element-477" data-mp="33wosvx8sz986">
                Softwash Pros provides top-tier exterior cleaning services to
                residential and commercial properties throughout the region.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-478" data-mp="2uxa4r4g3zaqu">
                {['Macomb County', 'Oakland County', 'Wayne County', 'St. Clair County', 'Shelby Township', 'Sterling Heights', 'Troy', 'Rochester'].map((city, idx) => <div key={idx} className="flex items-center text-gray-700" data-id="element-479" data-mp="mm0ybf68k45s" data-mpi={idx}>
                    <MapPin className="w-5 h-5 text-light-blue mr-2" data-id="element-480" data-mp="1jdbmc6p71yvb" />
                    {city}
                  </div>)}
              </div>
              <p className="text-navy font-semibold" data-id="element-481" data-mp="1acn8pd3pq0iy">
                Don't see your area? Call us to check availability!
              </p>
            </div>
            <div className="lg:w-1/2 w-full h-[400px] bg-gray-200 rounded-xl overflow-hidden shadow-inner flex items-center justify-center" data-id="element-482" data-mp="15godb5jyvi91">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d377194.4741488056!2d-83.56847055000001!3d42.59850125!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8824ca0110cb1d75%3A0x5776864e35b9c4d2!2sDetroit%20Metropolitan%20Area%2C%20MI!5e0!3m2!1sen!2sus!4v1715000000000!5m2!1sen!2sus" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Service Area Map - Detroit Metropolitan Area" data-id="element-483" data-mp="3q4b24yjipax0"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 9. Final CTA Banner */}
      <CTABanner data-id="element-484" data-mp="32cixdiqjthbk" />
    </div>;
}